import ModularService from 'app_services/admin/modular/modularService'
import { IModularListItem } from 'app_types/admin/modular/modularTypes'
import React, { FC, useCallback, useEffect, useMemo, useState } from 'react'
import ModularPublicCard from '../ModularPublicCard/ModularPublicCard'
import './ModularCarousel.scss'
import Slider from 'react-slick'
import useWindowWidth from 'app_hooks/useWindowWidth'
import { BsChevronLeft, BsChevronRight } from 'react-icons/bs'
import { Link } from 'react-router-dom'
import { routingService } from 'app_services/routingService'

const DEFAULT_ICON = require('app_assets/images/favicons/favicon.png')
const MOVIL_BREAKPOINT = 760

interface IModularCarouselProps {

}

const ModularCarousel: FC<IModularCarouselProps> = () => {
  const modularService = useMemo(() => new ModularService(), [])
  const [modulares, setModulares] = useState<IModularListItem[]>([])
  const { windowWidth } = useWindowWidth()

  const fetchModulares = useCallback(async () => {
    const response = await modularService.listExternal({ moodle_id: true })
    if (response?.code === 200) {
      setModulares(response.modulars)
    } else {
      setModulares([])
    }
  }, [modularService])

  useEffect(() => {
    fetchModulares()
  }, [fetchModulares])

  const getNumberItems = () => {
    const widthCard = 160
    const totalItems = Math.round((windowWidth - 200) / widthCard)
    return totalItems
  }

  const getModularRoute = (modular: IModularListItem) => {
    return `/academic-filter?${modular.filterCategories?.map((category) => `filterCategories=${category}`)?.join('&')}`
  }

  if (!modulares?.length) return null

  return (
    <div className='modular-carousel--container'>
      {windowWidth > MOVIL_BREAKPOINT && (
        <Slider
            arrows={true}
            className='slider-page'
            infinite={(modulares?.length >= getNumberItems()) ? true : false}
            slidesToShow={getNumberItems()}
            nextArrow={<BsChevronRight color='var(--primary)' />}
            prevArrow={<BsChevronLeft color='var(--primary)' />}
          >
          {modulares?.map((modular) => (
            <div
              key={modular._id}
              className='modular-carousel--item-slider'
            >
              <Link to={routingService.getPublicPath(getModularRoute(modular))}>
                <ModularPublicCard
                  key={modular._id}
                  title={modular.name}
                  image={modular.coverUrl ? modular.coverUrl : DEFAULT_ICON}
                />
              </Link>
            </div>
          ))}
        </Slider>
      )}
      {windowWidth <= MOVIL_BREAKPOINT && (
        <div className="modular-carousel--movil-container">
          {modulares?.slice(0, 8)?.map((modular) => (
            <Link to={routingService.getPublicPath(getModularRoute(modular))}>
              <ModularPublicCard
                key={modular._id}
                title={modular.name}
                image={modular.coverUrl ? modular.coverUrl : DEFAULT_ICON}
              />
            </Link>
          ))}
        </div>
      )}
    </div>
  )
}

export default ModularCarousel
